import React, { useEffect} from "react";
import { useFormik } from "formik";
import * as Yup from "yup"
export default function AddAdminBanks({onAdd,onEdit,BankToEdit,setBankToEdit }) {
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      hq_location: "",
      paybill: 0,
      image_url: ""
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required('Name is required').typeError("Plaese enter a string"),
      email: Yup.string().email('Invalid email format').required('Email is required').typeError("Please enter a valid email"),
      hq_location: Yup.string().required('Location is required').typeError("Please enter a string"),
      paybill: Yup.number().required('Paybill is required').typeError("Please enter an integer"),
      image_url: Yup.string().url('Invalid URL format').required('Image URL is required').typeError("Please enter the image_url"),
    }),
    onSubmit:async(values, { setSubmitting }) => {
      try {
        if (BankToEdit) {
          await onEdit(values)
          setBankToEdit(null)
          formik.resetForm()
        }
        else {
          await onAdd(values)
          setBankToEdit(null)
          formik.resetForm()
        }
      } catch (error) {
        console.error("An error ocuured adding or updating bank", error)
      }
      finally {
        setSubmitting(false)
      }

    }
  })

  useEffect(() => {
    if (BankToEdit) {
      formik.setValues(BankToEdit)
    }
  }, [BankToEdit])

  return (
    <div className=" max-w-full min-w-fit max-h-full min-h-fit ">
      <form onSubmit={formik.handleSubmit} className=" space-y-2">
        <label htmlFor="name">Name</label>
        <input
          type="text"
          id="name"
          name="name"
          value={formik.values.name}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          placeholder="Name"
          className="rounded-xl"
        />
        {formik.touched.name && formik.errors.name ? (
          <div className="text-red-500 italic">{formik.errors.name}</div>
        ) : null}

        <label htmlFor="email">Email</label>
        <input
          type="email"
          id="email"
          name="email"
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          placeholder="Email"
           className="rounded-xl"
        />
        {formik.touched.email && formik.errors.email ? (
          <div className="text-red-500 italic">{formik.errors.email}</div>
        ) : null}

        <label htmlFor="hq_location">HQ_Location</label>
        <input
          type="text"
          id="hq_location"
          name="hq_location"
          value={formik.values.hq_location}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          placeholder="hq_Location"
           className="rounded-xl"
        />
        {formik.touched.hq_location && formik.errors.hq_location ? (
          <div className="text-red-500">{formik.errors.hq_location}</div>
        ) : null}

        <label htmlFor="paybill">Paybill</label>
        <input
          type="number"
          id="paybill"
          name="paybill"
          value={formik.values.paybill}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          placeholder="paybill"
           className="rounded-xl"
        />
        {formik.touched.paybill && formik.errors.pyabill? (
          <div className="text-red-500 italic">{formik.errors.paybill}</div>
        ) : null}

        <label htmlFor="image_url">Image URL</label>
        <input
          type="text"
          id="image_url"
          name="image_url"
          value={formik.values.image_url}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          placeholder="Image URL"
           className="rounded-xl"
        />
        {formik.touched.image_url && formik.errors.image_url ? (
          <div className="text-red-500 italic">{formik.errors.image_url}</div>
        ) : null}

        <button type="submit" disabled={!formik.isValid || formik.isSubmitting} className="bg-blue-500 rounded-lg disabled:opacity-50 ml-4 ">{BankToEdit ? "Edit bank" : "Add bank"}</button>
      </form>
    </div>
  )
}